import { FC } from 'react';
import { NudosButton, NudosGenericModal } from '../NudosComponents';
import BordOneToneIcon from '../NudosComponents/BordOneToneIcon/BordOneToneIcon';

import './ModalMoveWithPendingConfiguration.scss';

interface IModalMoveWithPendingConfigurationProps {
  showPendingConfigurationModal: boolean;
  setShowPendingConfigurationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowProcessModal?: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  onConfirmContinue?: () => void;
  primaryButtonText: string;
}

const ModalMoveWithPendingConfiguration: FC<IModalMoveWithPendingConfigurationProps> = ({
  showPendingConfigurationModal,
  setShowPendingConfigurationModal,
  setShowProcessModal,
  message,
  onConfirmContinue,
  primaryButtonText
}: IModalMoveWithPendingConfigurationProps) => {
  const closeModal = () => {
    setShowPendingConfigurationModal(false);
  };

  const closeModalAndContinue = () => {
    setShowPendingConfigurationModal(false);
    if (onConfirmContinue) {
      onConfirmContinue();
    } else if (setShowProcessModal) {
      setShowProcessModal(true);
    }
  };

  if (!showPendingConfigurationModal) return null;

  return (
    <NudosGenericModal
      modalContent={
        <div className="modalMoveWithPendingConfiguration">
          <div className="alertIconContainer">
            <div className="alertIconYellow">
              <BordOneToneIcon variant="alertTriangleWarning" standardSize={20} stroke="#FFBB00" />
            </div>
          </div>
          <div className="titleModalContainer" dangerouslySetInnerHTML={{ __html: message }} />
          <div className="buttonsModalContainer">
            <NudosButton
              colorPalette="secondary"
              buttonText="No, cancelar"
              componentSize="small"
              handleClick={closeModal}
            />
            <NudosButton
              colorPalette="primary"
              buttonText={primaryButtonText}
              componentSize="small"
              handleClick={closeModalAndContinue}
            />
          </div>
        </div>
      }
    />
  );
};

export default ModalMoveWithPendingConfiguration;
